module.exports = __webpack_public_path__ + "static/img/nsf1.1a5bc18.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nsf1.gif
// module id = cVVO
// module chunks = 1